import React, { Component } from "react"
import * as Yup from "yup"
import { Formik, Form } from "formik"
import { apiProcess } from "../../api/api.js"
import * as Cookies from "js-cookie"
import { Modal, Button, Notification, Columns, Field } from "../../elements"

const intialValues = data => {
  return {
    first_name: Cookies.get("userFirstName")
      ? Cookies.get("userFirstName")
      : "",
    last_name: Cookies.get("userLastName") ? Cookies.get("userLastName") : "",
    phone: "",
    email: Cookies.get("userEmail") ? Cookies.get("userEmail") : "",
    message: ""
  }
}

const formValidation = Yup.object().shape({
  first_name: Yup.string()
    .nullable()
    .required("First Name is Required."),
  last_name: Yup.string()
    .nullable()
    .required("Last Name is Required."),
  phone: Yup.string()
    .nullable()
    .required("Phone is Required."),
  email: Yup.string()
    .email("Email address is not valid.")
    .nullable()
    .required("Email is Required."),
  message: Yup.string()
    .nullable()
    .required("Message is Required.")
})

class PartnerContactForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formSent: false,
      loading: false,
      submitError: false,
      showSuccess: false,
      showModal: false
    }
  }

  componentDidMount() {}

  handleForm = (setTouched, setFieldError, values, setSubmitting) => {
    this.setState({ loading: true, submitError: false })

    setTouched({
      first_name: true,
      last_name: true,
      phone: true,
      email: true,
      message: true
    })

    formValidation
      .validate(
        {
          first_name: values.first_name,
          last_name: values.last_name,
          phone: values.phone,
          email: values.email,
          message: values.message
        },
        { abortEarly: false }
      )
      .then(
        function(valid) {
          this.sendFormInfo(values)
        }.bind(this)
      )
      .catch(
        function(responseData) {
          for (let i = 0; i < responseData.inner.length; i++) {
            setFieldError(
              responseData.inner[i]["path"],
              responseData.inner[i]["message"]
            )
          }
          setSubmitting(false)
          this.setState({ loading: false })
        }.bind(this)
      )
  }

  sendFormInfo = values => {
    //alert()
    let formValues = {
      email: values.email,
      phone: values.phone,
      first_name: values.first_name,
      last_name: values.last_name,
      message: values.message,
      partner_pretty_id: this.props.partnerID
    }

    if (this.props.motorcycleUUID) {
      formValues["motorcycle"] = this.props.motorcycleUUID
    }

    apiProcess(
      "partners/dealer_inquiry",
      formValues,
      "partner-contact-form",
      "Dealer Contact Form"
    )
      .then(
        function(responseData) {
          this.setState({ loading: false, showSuccess: true })
        }.bind(this)
      )
      .catch(
        function() {
          this.setState({ loading: false, submitError: true })
        }.bind(this)
      )
  }

  render() {
    const { submitError, showSuccess } = this.state
    const {
      header,
      triggerText,
      submitButton,
      messagePlaceHolder,
      size,
      className,
      buttonOutlined,
    } = this.props

    return (
      <>
        <Button
          onClick={() => this.setState({ showModal: true })}
          fullwidth
          color="primary"
          size={size}
          className={className}
          outlined={buttonOutlined}
        >
          {triggerText}
        </Button>
        <Modal
          showClose={true}
          closeOnEsc={true}
          closeOnBlur={true}
          onClose={() => this.setState({ showModal: false })}
          show={this.state.showModal}
          size="medium"
          header={header}
          animation="fade"
        >
          <Formik
            initialValues={intialValues()}
            onSubmit={(
              values,
              { setTouched, setFieldError, setFieldValue, setSubmitting }
            ) =>
              this.handleForm(setTouched, setFieldError, values, setSubmitting)
            }
            render={({ errors, setFieldValue, values }) => {
              return (
                <React.Fragment>
                  <Form>
                    {submitError && (
                      <Notification color="danger" className="">
                        Sorry, we're having issues. Please try again.
                      </Notification>
                    )}
                    {showSuccess && (
                      <Notification color="success">
                        <p>
                          <strong>Your message has been sent.</strong>
                        </p>
                        <p>Someone from will get in touch with you soon.</p>
                      </Notification>
                    )}
                    <Columns className="mb-0">
                      <Columns.Column size={6}>
                        <Field
                          label="First Name"
                          error={errors.first_name}
                          name="first_name"
                          id="first_name"
                          placeholder={"First Name"}
                          type="input"
                          value={values.first_name}
                          onChange={({ value }) =>
                            setFieldValue("first_name", value)
                          }
                        />
                      </Columns.Column>
                      <Columns.Column size={6}>
                        <Field
                          label="Last Name"
                          type="input"
                          error={errors.last_name}
                          name="last_name"
                          placeholder="Last Name"
                          value={values.last_name}
                          onChange={({ value }) =>
                            setFieldValue("last_name", value)
                          }
                        />
                      </Columns.Column>
                    </Columns>
                    <Columns className="mb-0">
                      <Columns.Column size={6}>
                        <Field
                          error={errors.email}
                          type="input"
                          name="email"
                          id="email"
                          placeholder="Email"
                          label="Email"
                          value={values.email}
                          onChange={({ value }) =>
                            setFieldValue("email", value)
                          }
                        />
                      </Columns.Column>
                      <Columns.Column size={6}>
                        <Field
                          error={errors.phone}
                          type="input"
                          name="phone"
                          id="phone"
                          label={"Phone"}
                          placeholder="Phone"
                          value={values.phone}
                          onChange={({ value }) =>
                            setFieldValue("phone", value)
                          }
                        />
                      </Columns.Column>
                    </Columns>
                    <Field
                      label="Message"
                      type="textarea"
                      name="message"
                      id="message"
                      error={errors.message}
                      placeholder={messagePlaceHolder}
                      onChange={({ value }) => setFieldValue("message", value)}
                      value={values.message}
                    />
                    <Button
                      type="submit"
                      color="primary"
                      size="medium"
                      fullwidth
                      loading={this.state.loading}
                      disabled={this.state.loading}
                    >
                      {submitButton}
                    </Button>
                    <p className="is-size-7 has-text-grey my-3">
                      By clicking here, you authorize Twisted Road and its
                      sellers/partners to contact you by text, phone call, and
                      email. You also agree to our privacy statement and our
                      terms and conditions.
                    </p>
                  </Form>
                </React.Fragment>
              )
            }}
          />
        </Modal>
      </>
    )
  }
}

export default PartnerContactForm

PartnerContactForm.defaultProps = {
  motorcycleUUID: null,
  header: "Request Info",
  triggerText: "REQUEST INFO",
  submitButton: "Submit",
  messagePlaceHolder: "",
  size: "medium",
  className: null,
  partnerID: null,
  buttonOutlined: false,
  showOwnerName: false
}
